import { BaseApi } from './base-api.service';
import URL from '../../constants/api-constants';
import { generatePath } from 'react-router-dom';
import { CyclesCountResponse } from '../../types/cycle';
import ContractStatus from '../../enums/status-contracts-location.enum';

export class LocationService {
  private static readonly apiService = new BaseApi();

  static async getCyclesCount(payload: { locationId: string, query?: { contractStatus: ContractStatus } }): Promise<CyclesCountResponse> {
    const path = generatePath(URL.CYCLES_COUNT_BY_LOCATION, { locationId: payload.locationId });
    const contractStatus = payload.query?.contractStatus || ContractStatus.OPEN;

    const data = await this.apiService.api.get<CyclesCountResponse>(path, { params: { contractStatus } });

    return data.data;
  }
}
